
import "./files.tsx";
import { elements, $$, storage, transition } from "./app.tsx";

let a: HTMLElement;
let b = <div hidden={"until-found"} />;

export let editorLayout$: EditorLayout = storage.get("editor-layout") ?? "aside";
{
	// horizontal / vertical layout
	const button = elements.toggleLayoutButton;
	// console.error("current layout:", currentLayout);
	// document.documentElement.dataset.editorLayout = editorLayout$;
	button.addEventListener("click", async () => {
		console.log(button, "clicked");
		await transition(async () => {
			editorLayout$ = editorLayout$ === "aside" ? "stacked" : "aside";
			// document.documentElement.dataset.editorLayout = editorLayout$;
		}, { name: "toggling-layout" });
		storage.set("editor-layout", editorLayout$);
	});

	const editor = elements.editor;
	const dragger = editor.querySelector(".dragger");

	let dragging = false;
	let relativeDraggerCoordinate: number;
	let draggerSize: number;
	let containerCoordinate: number;
	let containerSize: number;

	dragger.addEventListener("pointerdown", ({ clientX, clientY }) => {
		editor.classList.add("dragging");
		dragging = true;
		const stacked = editorLayout$ === "stacked";
		let draggerCoordinate: number;
		({ [stacked ? "y" : "x"]: draggerCoordinate, [stacked ? "height" : "width"]: draggerSize } = dragger.getBoundingClientRect());
		relativeDraggerCoordinate = (stacked ? clientY : clientX) - draggerCoordinate;
		({ [stacked ? "y" : "x"]: containerCoordinate, [stacked ? "height" : "width"]: containerSize } = editor.getBoundingClientRect());
	});

	window.addEventListener("pointerup", () => {
		if (!dragging) return;
		editor.classList.remove("dragging");
		dragging = false;
	});

	window.addEventListener("pointermove", ({ clientX, clientY }) => {
		if (!dragging) return;
		const stacked = editorLayout$ === "stacked";
		const splitProportion = ((stacked ? clientY : clientX) - relativeDraggerCoordinate - containerCoordinate) / (containerSize - draggerSize);
		editor.style.setProperty("--split-proportion", splitProportion);
	});
}

